import {
  NBS_API_EDIT_PROFILE_REQUEST,
  NBS_API_EDIT_PROFILE_SUCCESS,
  NBS_API_EDIT_PROFILE_FAILURE,
  RESET_EDIT_PROFILE,
  SAVE_EDIT_PROFILE_DATA,
} from '../../constants/actions';

import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiEditProfileRequest() {
  return { type: NBS_API_EDIT_PROFILE_REQUEST };
}
function nbsApiEditProfileSuccess(response, from) {
  return {
    type: NBS_API_EDIT_PROFILE_SUCCESS,
    response,
    from,
  };
}
function nbsApiEditProfileError(error) {
  return {
    type: NBS_API_EDIT_PROFILE_FAILURE,
    error: error.cause || error,
  };
}
export function nbsApiEditProfile(data) {
  const url = 'editProfile';
  if (data.language) {
    strings.setLanguage(data.language);
  } else {
    data.language = strings.getLanguage();
  }

  let from = '';
  if (data.from) {
    from = data.from;
  }
  return (dispatch) => {
    dispatch(nbsApiEditProfileRequest());
    return nbsApi(url, data)
      .then((response) => dispatch(nbsApiEditProfileSuccess(response, from)))
      .catch((error) => dispatch(nbsApiEditProfileError(error)));
  };
}
export function resetEditProfile() {
  return (dispatch) => dispatch({ type: RESET_EDIT_PROFILE });
}
export function saveEditProfileData(data) {
  return (dispatch) => dispatch({ type: SAVE_EDIT_PROFILE_DATA, data });
}
